<script lang="ts" setup>

const props = defineProps<{
    item: any
}>();

const homeDesignItem = props?.item;
const id = homeDesignItem.slug;
const reduceToArray = (key: string) => Array.from(new Set(
    homeDesignItem?.homeDesignDetails?.homeDesignVariations
        .map((obj: any) => obj[key])
        .reduce((acc, v) => acc.concat(v.toString().toLowerCase()), [])
));

const blocks = reduceToArray('landWidth');
const sizes = reduceToArray('totalFloorAreaSqm');
const carSpaces = reduceToArray('carSpaces');
const bathrooms = reduceToArray('bathrooms');
const bedrooms = reduceToArray('bedrooms');
const storeys = reduceToArray('storeys');
const variations = reduceToArray('variationName');

const selectedVariation = ref(0);

</script>
<template>
    <div :class="`col-12 col-md-6 col-lg-4 house-item mb-3 mb-md-0`"
        :id="`house-item-${id}`"
        :data-storeys="JSON.stringify(storeys)"
        :data-blocks="JSON.stringify(blocks)"
        :data-bathrooms="JSON.stringify(bathrooms)"
        :data-sizes="JSON.stringify(sizes)"
        :data-bedrooms="JSON.stringify(bedrooms)"
        :data-car-spaces="JSON.stringify(carSpaces)">
        <div class="card h-100 w-100 border-0 bg-wh-brown card-wrapper">
            <div class="tab-content" id="nav-tabContent">
                <a :href="item?.uri" :aria-label="item?.title">
                    <NuxtImg v-if="item?.featuredImage?.node?.mediaItemUrl" :class="`card-img-top ratio ratio-4x3`"
                        :src="item?.homeDesignDetails?.homeDesignVariations[selectedVariation]?.heroImage?.node?.mediaItemUrl"
                        loading="lazy" format="webp" :srcset="item?.homeDesignDetails?.homeDesignVariations[selectedVariation]?.heroImage?.node?.srcSet"
                        :alt="item?.title"
                        :quality="80"
                        sizes="sm:300px, md:350px"
                    />
                </a>
            </div>
            <div :class="`card-body px-0 pb-0`">
                <div class="row d-flex justify-content-stretch align-items-start border-1 border-dark">
                    <div class="col-auto">
                        <h4 class="card-title mt-3">
                            <a :href="item?.uri" class="text-primary" :aria-label="`home-design ${item?.title}`">{{ item?.title }}</a>
                        </h4>
                    </div>
                    <div class="col">
                        <ul class="nav justify-content-end flex-wrap mt-3">
                            <li class="nav-item" v-for="(variation, k) in item?.homeDesignDetails?.homeDesignVariations">
                                <a class="variation-name py-0 heading nav-link house-design-link text-dark-2"
                                   :class="{ 'active': k === selectedVariation && item?.homeDesignDetails?.homeDesignVariations?.length >= 2 }"
                                   :aria-label="variation?.variationName"
                                   @click="selectedVariation = k">{{ variation?.variationName }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="w-100">
                    <p v-for="(v, k) in item?.homeDesignDetails?.homeDesignVariations"
                        :class="`d-flex flex-wrap align-items-center ${k === selectedVariation ? '' : 'd-none'} house-desc mb-3 mb-md-0 details-text`"
                        :id="`house-desc`">
                        <span>{{v?.bedrooms[0] || 0}}&nbsp;&nbsp;BED</span>
                        <span class="mx-3 details-separator">&bullet;</span>
                        <span>{{v?.bathrooms[0] || 0}}&nbsp;&nbsp;BATH</span>
                        <span class="mx-3 details-separator">&bullet;</span>
                        <span>{{v?.carSpaces[0] || 0}}&nbsp;&nbsp;CAR</span>
                        <span class="mx-3 details-separator">&bullet;</span>
                        <span>{{v?.totalFloorAreaSqm?.toLocaleString()}}m2</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.house-design-link {
    cursor: pointer;
}

.nav-link.house-design-link.active {
    background: var(--bs-color-light);
    color: var(--bs-secondary);
}

.nav-link.house-design-link:hover {
    color: var(--var-dark-color);
}

.nav-link.house-design-link.active:hover {
    color: var(--bs-secondary);
}

.details-separator {
    display: flex;
    align-items: center;
    line-height: 1;
}

.details-text {
    margin-bottom: 0 !important;
}
</style>